import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { DataTable } from "@ploy-ui/core";
import { FormattedMessage } from "react-intl";
import { RefinancingResource, FulfillmentResource, useResourceWithInvalidate } from "@ploy-lib/rest-resources";
import { useAppLoad } from "../../appLoadContext";
addRegisteredSectionLayout({
    name: "FulfillmentSection",
    displayName: "FulfillmentSection",
    settings: {}
});
addRegisteredSectionLayout({
    name: "RefinancingSection",
    displayName: "RefinancingSection",
    settings: {}
});
const columns = [
    {
        field: "contractId",
        title: (_jsx(FormattedMessage, { id: "dploy.fulfillmentSection.contractId.header", defaultMessage: "Contract number" }))
    },
    {
        field: "text",
        title: (_jsx(FormattedMessage, { id: "dploy.fulfillmentSection.tekst.header", defaultMessage: "Text." }))
    },
    {
        field: "matureDate",
        title: (_jsx(FormattedMessage, { id: "dploy.fulfillmentSection.matureDate.header", defaultMessage: "Maturity Date." }))
    },
    {
        field: "refinancedAmount",
        title: (_jsx(FormattedMessage, { id: "dploy.fulfillmentSection.refinancedAmount.header", defaultMessage: "Outstanding debt." }))
    }
];
const emptyArray = [];
const FinancingSection = (props) => {
    const { className, onClick, financingCode } = props;
    const { applicationNumber, id: appSessionId } = useAppLoad();
    const resourceBase = financingCode === "REFINANCING"
        ? RefinancingResource.list()
        : FulfillmentResource.list();
    const result = useResourceWithInvalidate(resourceBase, appSessionId
        ? {
            applicationNumber
        }
        : null) ?? emptyArray;
    return (_jsx("div", { className: className, onClick: onClick, children: _jsx(Suspense, { fallback: null, children: _jsx(DataTable, { columns: columns, data: result, listCellsBreakpoint: "xs", options: {
                    search: false,
                    grouping: false,
                    showEmptyDataSourceMessage: false,
                    emptyRowsWhenPaging: false,
                    paging: false,
                    header: true,
                    toolbar: false,
                    idSynonym: "contractId"
                } }) }) }));
};
const FulfillmentSection = (props) => {
    return _jsx(FinancingSection, { ...props, financingCode: "FULFILLMENT" });
};
const RefinancingSection = (props) => {
    return _jsx(FinancingSection, { ...props, financingCode: "REFINANCING" });
};
FulfillmentSection.displayName = "DployFulfillmentSection";
RefinancingSection.displayName = "DployRefinancingSection";
export { FulfillmentSection, RefinancingSection };
//# sourceMappingURL=FinancingSections.js.map